import { Typography } from '@mui/material';
import { AddWhiteIcon, NoDocumentsNew, UploadIcon } from '../../assets/images';
import { MuiButton } from '../atoms/buttonComponent';
import { MuiStack } from '../atoms/stackComponent';
var NoDocumentFoundPage = function (props) {
    var title = props.title, paragraph = props.paragraph, height = props.height, buttonUpload = props.buttonUpload, buttonNew = props.buttonNew, onButtonNewClick = props.onButtonNewClick;
    return /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        bgcolor: '#FFFFFF',
        minHeight: height ? height : '90%',
        spacing: 2,
        padding: 2,
        justifyContent: 'center',
        alignItems: 'center'
    }, /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement("img", {
        id: "blankDocIcon",
        src: NoDocumentsNew,
        alt: "altimg"
    })), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Typography, {
        id: "blankDocTitle",
        variant: "h1",
        sx: {
            textAlign: 'center'
        }
    }, title)), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Typography, {
        id: "blankDocParagraph",
        variant: "h4",
        sx: {
            color: '#8593A3',
            textAlign: 'center'
        }
    }, paragraph)), /*#__PURE__*/ React.createElement(MuiStack, {
        id: "spareIssueButtonStack",
        alignContent: 'center',
        justifyContent: 'center'
    }, buttonUpload && /*#__PURE__*/ React.createElement(MuiStack, {
        marginRight: 3
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        size: "large",
        color: "primary",
        id: "spareIssueUploadButton",
        disabled: true,
        sx: {
            borderColor: "primary"
        },
        name: buttonUpload,
        variant: "outlined",
        startIcon: /*#__PURE__*/ React.createElement("img", {
            src: UploadIcon
        })
    })), buttonNew && /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(MuiButton, {
        size: "large",
        color: "primary",
        id: "spareIssueNewButton",
        onClick: onButtonNewClick,
        name: buttonNew,
        variant: "contained",
        startIcon: /*#__PURE__*/ React.createElement("img", {
            src: AddWhiteIcon,
            color: "#FFFFFF"
        })
    }))));
};
export default NoDocumentFoundPage;
